import { useMemo, useState } from 'react'

// Une recherche qui filtre une liste au fil de la frappe. Utile dès qu'une
// collectivité dépasse la dizaine d'agents ou de démarches : cocher dans une
// liste de quarante lignes est vite pénible.
export default function Filtre({ valeur, onChange, placeholder, nb, total }) {
  return (
    <div className="filtre">
      <label className="sr" htmlFor="filtre">Rechercher</label>
      <input id="filtre" type="search" value={valeur} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} />
      {valeur && (
        <span className="compte">
          {nb} sur {total}
          <button className="lien-mini" onClick={() => onChange('')}>tout afficher</button>
        </span>
      )}
    </div>
  )
}

// Rapproche deux textes sans se soucier des accents ni de la casse : quelqu'un
// qui tape « prunier » doit trouver « Prunier », et « eleve » doit trouver
// « élève ».
export function normaliser(texte) {
  return (texte || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export function useRecherche(liste, requete, champs) {
  return useMemo(() => {
    const q = normaliser(requete).trim()
    if (!q) return liste
    const mots = q.split(/\s+/)
    return liste.filter((item) => {
      const foin = normaliser(champs.map((c) => item[c] || '').join(' '))
      return mots.every((mot) => foin.includes(mot))
    })
  }, [liste, requete, champs])
}
